<pbc-sorter [config]="BerichtsVorlagenSorterConfig" [sorter]="berichtsVorlagen.sorter$ | async" (sorterChange)="berichtsVorlagen.sorter$.next($event)"></pbc-sorter>
